import {Capacitor} from '@capacitor/core';

export interface ApiEnvironment {
  name: string;
  url: string;
  domain?: string;
}

export const API_ENVIRONMENT_NAMES = {
  LOCAL: 'Local',
  DEV: 'Dev',
  QA: 'QA',
  PERSONAL: 'Personal',
  FARM: 'Farm',
  CENTRAL: 'Central',
} as const;

export const ENVIRONMENT_NAMES = {
  LOCALHOST: 'localhost',
  DEV: 'dev',
  QA: 'qa',
  PERSONAL: 'personal',
  FARM: 'farm',
  CENTRAL: 'central',
  BETA: 'beta',
  DOCKER: 'docker',
} as const;

export const API_ENVIRONMENT_URLS = {
  BETA: 'https://ophanim2-api-beta.timbergrove.com',
  DEV: 'https://ophanim-api-dev.timbergrove.com',
  QA: 'https://qa-api.fullsked.com',
  PERSONAL: 'https://personal-api.fullsked.com',
  FARM: 'https://farm-api.fullsked.com',
  CENTRAL: 'https://central-api.fullsked.com',
} as const;

export const API_FRONTEND_ENVIRONMENT_URLS = {
  Local: `${window.location.protocol}//${window.location.host}`,
  Beta: 'https://ophanim-dev.timbergrove.com',
  Dev: 'https://ophanim-dev.timbergrove.com',
  QA: 'https://qa.fullsked.com',
  Personal: 'https://personal.fullsked.com/',
  Farm: 'https://farm.fullsked.com/',
  Central: 'https://central.fullsked.com/',
} as const;

export const getLocalApiUrl = (): string => {
  if (typeof window !== 'undefined') {
    return `${window.location.protocol}//${window.location.hostname}:3000`;
  }
  return 'http://localhost:3000';
};

export const API_ENVIRONMENTS: ApiEnvironment[] = [
  {
    name: API_ENVIRONMENT_NAMES.LOCAL,
    url: getLocalApiUrl(),
    domain: API_FRONTEND_ENVIRONMENT_URLS[API_ENVIRONMENT_NAMES.LOCAL],
  },
  {
    name: API_ENVIRONMENT_NAMES.DEV,
    url: API_ENVIRONMENT_URLS.DEV,
    domain: API_FRONTEND_ENVIRONMENT_URLS[API_ENVIRONMENT_NAMES.DEV],
  },
  {
    name: API_ENVIRONMENT_NAMES.QA,
    url: API_ENVIRONMENT_URLS.QA,
    domain: API_FRONTEND_ENVIRONMENT_URLS[API_ENVIRONMENT_NAMES.QA],
  },
  {
    name: API_ENVIRONMENT_NAMES.PERSONAL,
    url: API_ENVIRONMENT_URLS.PERSONAL,
    domain: API_FRONTEND_ENVIRONMENT_URLS[API_ENVIRONMENT_NAMES.PERSONAL],
  },
  {
    name: API_ENVIRONMENT_NAMES.FARM,
    url: API_ENVIRONMENT_URLS.FARM,
    domain: API_FRONTEND_ENVIRONMENT_URLS[API_ENVIRONMENT_NAMES.FARM],
  },
  {
    name: API_ENVIRONMENT_NAMES.CENTRAL,
    url: API_ENVIRONMENT_URLS.CENTRAL,
    domain: API_FRONTEND_ENVIRONMENT_URLS[API_ENVIRONMENT_NAMES.CENTRAL],
  },
];

const ENV_NAME_TO_API_ENV_KEY: Record<string, keyof typeof API_ENVIRONMENT_NAMES> = {
  localhost: 'LOCAL',
  dev: 'DEV',
  qa: 'QA',
  personal: 'PERSONAL',
  farm: 'FARM',
  central: 'CENTRAL',
  beta: 'DEV',
};

export const getFrontendDomain = (envName: string, isMobilePlatform: boolean): string => {
  if (isMobilePlatform) {
    const platform = typeof window !== 'undefined' ? Capacitor.getPlatform() : null;
    if (platform === 'ios' || platform === 'android') {
      return API_FRONTEND_ENVIRONMENT_URLS[API_ENVIRONMENT_NAMES.DEV];
    }
  }

  const normalizedEnvName = envName?.toLowerCase() || 'localhost';
  const apiEnvKey = ENV_NAME_TO_API_ENV_KEY[normalizedEnvName] || 'LOCAL';
  return API_FRONTEND_ENVIRONMENT_URLS[API_ENVIRONMENT_NAMES[apiEnvKey]];
};
